module.exports = __webpack_public_path__ + "static/media/CreditAnalysis.02694f9a.svg";